import React, { useEffect, useState } from 'react';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import AppTableContainer from '@projectK/components/AppTableContainer';
import TableItem from './TableItem';
import PropTypes from 'prop-types';
import jwtAxios from '@projectK/services/auth/JWT';
import AppScrollbar from '@projectK/components/AppScrollbar';

const ActivityHistory = () => {
  const { user } = useAuthUser();
  const [settings, setBasicSettings] = useState([]);

  useEffect(() => {
    fetchAttendanceData();
  }, []);

  const fetchAttendanceData = async () => {
    try {
      const response = await jwtAxios.get(
        `/attendance/activityhistory/${user.id}`,
      );
      const { data } = response;
      setBasicSettings(data);
    } catch (error) {
      setBasicSettings([]);
    }
  };
  return (
    <AppTableContainer>
      <AppScrollbar>
        {/* Render the child component and pass the data */}
        {settings.map((item, index) => (
          <TableItem key={index} data={item} />
        ))}
      </AppScrollbar>
    </AppTableContainer>
  );
};

export default ActivityHistory;

ActivityHistory.propTypes = {
  studentRankings: PropTypes.array,
};
